var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 40,
    viewBox: "0 0 200 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4611 5.0249H0L14.7305 29.4317L29.4611 5.0249Z",
    fill: "#5EB3E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 32.6221H29.3813V8.33496L14.7705 32.6221Z",
    fill: "#5EB3E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 32.6221H29.3813V8.33496L14.7705 32.6221Z",
    fill: "url(#paint0_linear_29_10479)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.33496V32.6221H14.6108L0 8.33496Z",
    fill: "#5EB3E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.33496V32.6221H14.6108L0 8.33496Z",
    fill: "url(#paint1_linear_29_10479)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4611 5.0249L14.7305 29.4317L0 5.0249H29.4611Z",
    fill: "url(#paint2_linear_29_10479)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2031 17.4678H92.0554C91.4167 10.2495 85.5085 4.50671 78.2031 4.10791V17.4678Z",
    fill: "#5EB3E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2031 17.4678H92.0554C91.4167 10.2495 85.5085 4.50671 78.2031 4.10791V17.4678Z",
    fill: "url(#paint3_linear_29_10479)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5669 19.1029V17.9065V17.4279V4.10791C68.8224 4.54659 62.6348 10.9673 62.6348 18.8238C62.6348 26.9593 69.2216 33.5795 77.3653 33.5795C85.3893 33.5795 91.9362 27.1587 92.0958 19.1428L76.5669 19.1029Z",
    fill: "#5EB3E4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5669 19.1029V17.9065V17.4279V4.10791C68.8224 4.54659 62.6348 10.9673 62.6348 18.8238C62.6348 26.9593 69.2216 33.5795 77.3653 33.5795C85.3893 33.5795 91.9362 27.1587 92.0958 19.1428L76.5669 19.1029Z",
    fill: "url(#paint4_linear_29_10479)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.798 30.1894V5.0249H31.3369L60.798 30.1894Z",
    fill: "#5EB3E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.798 30.1894V5.0249H31.3369L60.798 30.1894Z",
    fill: "url(#paint5_linear_29_10479)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3369 7.21826V32.622H60.798V32.5822L31.3369 7.21826Z",
    fill: "#5EB3E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3369 7.21826V32.622H60.798V32.5822L31.3369 7.21826Z",
    fill: "url(#paint6_linear_29_10479)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.848 4.78584H120.399L122.555 10.9673L123.673 14.078H123.832L125.03 10.8875L127.265 4.78584H131.417L133.054 19.8606H129.261L128.742 14.4768L128.303 10.4488H128.183L126.706 14.4369L124.671 19.8606H121.836L119.96 14.397L118.563 10.2893H118.443L118.044 14.397L117.485 19.8207H114.052L115.848 4.78584ZM135.888 19.8207H139.162V10.4488H139.241L146.547 19.8207H149.661V4.78584H146.387V13.9583H146.307L138.922 4.78584H135.888V19.8207ZM152.455 12.5625C152.455 17.6672 155.649 20.1398 160.399 20.1398C162.395 20.1398 164.231 19.6213 165.948 18.7041V11.9244H162.315V17.1487C161.836 17.2285 161.397 17.2684 160.878 17.2684C157.844 17.2684 156.207 15.394 156.207 12.1238C156.207 8.89351 158.363 7.2983 160.798 7.2983C162.355 7.2983 164.351 7.61734 165.828 8.57447V5.38404C164.83 4.98524 162.994 4.4668 160.718 4.4668C155.688 4.4668 152.455 7.6971 152.455 12.5625Z",
    fill: "#53575A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.002 25.3641H120.519L125.23 39.8008H123.433L122.036 35.1747H116.727L115.01 39.8008H113.453L119.002 25.3641ZM117.246 33.7789H121.637L120.918 31.3462L119.721 27.3183H119.641L118.164 31.3063L117.246 33.7789ZM128.104 39.8008H129.78V25.3641H128.104V39.8008ZM133.972 25.3641H138.283C141.198 25.3641 143.194 26.6403 143.194 29.7111C143.194 31.5057 142.275 32.9813 140.399 33.6991L144.391 39.8008H142.355L138.842 34.0979C138.363 34.1777 137.844 34.1777 137.325 34.1777H135.649V39.7609H133.972V25.3641ZM135.649 26.7201V32.7819H137.206C139.521 32.7819 141.517 32.3033 141.517 29.751C141.517 27.6772 140.16 26.7201 137.685 26.7201H135.649ZM147.146 39.8008H155.609V38.405H148.822V25.3641H147.146V39.8008ZM158.164 39.8008H159.84V25.3641H158.164V39.8008ZM164.032 39.8008H165.709V27.9563H165.749L173.972 39.7609H175.569V25.3641H173.892V36.9693H173.852L165.669 25.3641H164.072V39.8008H164.032ZM179.8 39.8008H188.543V38.405H181.437V33.061H187.226V31.6652H181.437V26.7201H188.343V25.3242H179.76V39.8008H179.8ZM191.058 39.2026C192.375 39.721 193.653 40.0002 195.01 40.0002C197.685 40.0002 200 38.6044 200 35.8925C200 33.2205 197.645 32.3432 195.489 31.5057C193.693 30.7878 192.575 30.2295 192.575 28.7141C192.575 27.3581 193.852 26.5207 195.489 26.5207C196.886 26.5207 198.283 26.9195 199.441 27.5974V25.9224C198.443 25.4439 197.126 25.085 195.489 25.085C193.014 25.085 190.938 26.5207 190.938 29.0331C190.938 31.3462 192.814 32.2634 194.77 32.9813C196.687 33.739 198.363 34.2574 198.363 35.9723C198.363 37.5675 196.966 38.4848 195.13 38.4848C193.693 38.4848 192.136 38.0461 191.058 37.4877V39.2026Z",
    fill: "#00ADEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_10479",
    x1: 15.9981,
    y1: 33.8484,
    x2: 35.4397,
    y2: 14.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_10479",
    x1: -6.07784,
    y1: 14.4067,
    x2: 13.3638,
    y2: 33.8678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_10479",
    x1: 4.94012,
    y1: 19.651,
    x2: 24.5014,
    y2: 0.0701877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_10479",
    x1: 88.9994,
    y1: 20.0296,
    x2: 76.7053,
    y2: 5.36346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29_10479",
    x1: 85.4481,
    y1: 31.2962,
    x2: 66.5168,
    y2: 8.71231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29_10479",
    x1: 44.9996,
    y1: 18.6739,
    x2: 59.7154,
    y2: 3.94342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#0B0A0A",
    stopOpacity: 0.5962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29_10479",
    x1: 33.7205,
    y1: 34.6201,
    x2: 46.2272,
    y2: 19.7002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0368441,
    stopColor: "#211D1E",
    stopOpacity: 0.0387832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6023,
    stopColor: "#090808",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEn);
export default __webpack_public_path__ + "static/media/Logo-en.cbf80ebd95ee1cb044c486293459ffd0.svg";
export { ForwardRef as ReactComponent };